
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
    name: 'RLogoIcon',
})
export default class RLogoIcon extends Vue {
    @Prop({ default: '50' }) private height?: string;
}
